export const SIZE_PICKER_DEFAULT_VALUE = "SIZE_PICKER_DEFAULT_VALUE";
